/**
 * Filters Module
 * Handles UI filters and event filtering logic
 */

import { eventTypesTranslate } from '../utils/translation';
import { getMap, getControlAreaLayers, getAllEventsLayers } from './mapConfig';
import { fetchCSVDataWithEventTypeAndDate } from './eventManager';
import { selectedCountry } from './countryManager';

/**
 * Populate event types dropdown
 */
export function setEventsTypeList() {
    const eventsTypeList = document.getElementById('eventType');
    console.log('Setting event types list, element:', eventsTypeList);
    
    const eventTypes = eventTypesTranslate();
    console.log('Event types data:', eventTypes);

    if (!eventsTypeList) {
        console.error('Event type dropdown element not found!');
        return;
    }

    if (!eventTypes) {
        console.error('Event types translation returned null/undefined');
        return;
    }

    for (const eventType in eventTypes) {
        const option = document.createElement("option");
        option.text = eventType;
        option.value = eventTypes[eventType];
        eventsTypeList.appendChild(option);
    }
    
    console.log(`Added ${Object.keys(eventTypes).length} event type options`);
}

/**
 * Initialize filter modal
 */
function initializeFilterModal() {
    const floatingFilterBtn = document.getElementById('floatingFilterBtn');
    const filterModal = document.getElementById('filterModal');
    const closeFilterModal = document.getElementById('closeFilterModal');
    const resetFilterButton = document.getElementById('resetFilterButton');

    // Open modal
    if (floatingFilterBtn) {
        floatingFilterBtn.addEventListener('click', () => {
            filterModal.style.display = 'flex';
            // Force reflow before adding active class
            filterModal.offsetHeight;
            filterModal.classList.add('active');
            console.log('Filter modal opened');
        });
    }

    // Close modal function
    const closeModal = () => {
        filterModal.classList.remove('active');
        // Wait for transition to complete before hiding
        setTimeout(() => {
            if (!filterModal.classList.contains('active')) {
                filterModal.style.display = 'none';
            }
        }, 300); // Match transition duration
        console.log('Filter modal closed');
    };

    // Close modal
    if (closeFilterModal) {
        closeFilterModal.addEventListener('click', closeModal);
    }

    // Close modal when clicking outside
    filterModal.addEventListener('click', (e) => {
        if (e.target === filterModal) {
            closeModal();
            console.log('Filter modal closed (outside click)');
        }
    });

    // Close modal on Escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && filterModal.classList.contains('active')) {
            closeModal();
            console.log('Filter modal closed (Escape key)');
        }
    });

    // Reset filters
    if (resetFilterButton) {
        resetFilterButton.addEventListener('click', () => {
            document.getElementById('startDate').value = '';
            document.getElementById('endDate').value = '';
            document.getElementById('eventType').selectedIndex = 0;
            document.getElementById('controlAreaSwitch').checked = true;
            document.getElementById('eventsSwitch').checked = true;
            console.log('Filters reset to default');
        });
    }
}

/**
 * Initialize filter controls and event listeners
 */
export function initializeFilters() {
    setEventsTypeList();
    initializeFilterModal();

    const controlAreaSwitch = document.getElementById('controlAreaSwitch');
    const eventsSwitch = document.getElementById('eventsSwitch');
    const applyFilterButton = document.getElementById('applyFilterButton');
    const startDate = document.getElementById('startDate');
    const endDate = document.getElementById('endDate');
    const eventType = document.getElementById('eventType');

    // Set default states
    eventsSwitch.checked = true;
    controlAreaSwitch.checked = true;

    // Apply filter button
    applyFilterButton.addEventListener("click", function () {
        console.log("applyFilterButton clicked");
        console.log("startDate", startDate.value);
        console.log("endDate", endDate.value);
        console.log("eventsSwitch", eventsSwitch.checked);
        console.log("controlAreaSwitch", controlAreaSwitch.checked);
        console.log("eventType", eventType.value);
        console.log("Selected Country>>>", selectedCountry);

        if (eventsSwitch.checked) {
            const allEventsLayers = getAllEventsLayers();
            if (allEventsLayers != null) {
                allEventsLayers.clearLayers();
            }
            fetchCSVDataWithEventTypeAndDate(
                selectedCountry, 
                startDate.value, 
                endDate.value, 
                eventType.value
            );
        }
    });

    // Start date change
    startDate.addEventListener("change", function () {
        console.log("startDate changed", startDate.value);
    });

    // End date change
    endDate.addEventListener("change", function () {
        console.log("endDate changed", endDate.value);
    });

    // Events switch toggle
    eventsSwitch.addEventListener("change", function () {
        const map = getMap();
        const allEventsLayers = getAllEventsLayers();
        if (eventsSwitch.checked) {
            console.log("set Events Layer");
            if (map && allEventsLayers) {
                map.addLayer(allEventsLayers);
            }
        } else {
            console.log("clear Events Layer");
            if (map && allEventsLayers) {
                map.removeLayer(allEventsLayers);
            }
        }
    });

    // Control area switch toggle
    controlAreaSwitch.addEventListener("change", function () {
        const map = getMap();
        const controlAreaLayers = getControlAreaLayers();
        if (controlAreaSwitch.checked) {
            console.log("set controlArea Layer");
            if (map && controlAreaLayers) {
                map.addLayer(controlAreaLayers);
            }
        } else {
            console.log("clear controlArea Layer");
            if (map && controlAreaLayers) {
                map.removeLayer(controlAreaLayers);
            }
        }
    });

    // Event type change
    eventType.addEventListener("change", function () {
        console.log("eventType changed", eventType.value);
    });
}
